import FirestoreService from "../firestore";
import { EnergySource } from "@/types/energy-source/energy-source.types";

interface FirestoreResponse {
    entity?: string;
    [key: string]: any;
}

export const energySourceService = {
    create: async (body: Omit<EnergySource, "createdAt" | "updatedAt">, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "create-energySource",
            body,
            "setup_energyConsumption",
            issuedBy
        )) as FirestoreResponse;

        const documentId = result?.entity;
        if (!documentId) {
            throw new Error("Failed to create energy source: No ID returned");
        }
        return documentId;
    },

    edit: async (id: string, body: Partial<EnergySource>, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "edit-energySource",
            { id, ...body },
            "setup_energyConsumption",
            issuedBy
        )) as FirestoreResponse;
        return result;
    },

    delete: async (id: string, issuedBy?: string) => {
        return FirestoreService.request(
            "delete-energySource",
            { id },
            "setup_energyConsumption",
            issuedBy
        ) as Promise<FirestoreResponse>;
    }
}; 